<template>
	<v-container>
		<div class="py-2">
			<v-breadcrumbs :items="breadcrumbs" class="px-0">
				<template v-slot:divider>
					<v-icon>mdi-chevron-right</v-icon>
				</template>
			</v-breadcrumbs>

			<v-card elevation="0">
				<v-tabs v-model="activeTab" background-color="transparent">
					<v-tab class="text-none">Listado Avanzado</v-tab>
					<v-tab class="text-none">Listado General</v-tab>
				</v-tabs>
				<v-divider />
				<v-tabs-items v-model="activeTab">

					<!-- ── Tab 0: Listado Avanzado (contenido existente sin modificar) ── -->
					<v-tab-item>
						<v-card-text class="pa-8">
							<v-row>
						<!-- ── Panel izquierdo: filtros + resultados ── -->
						<v-col cols="12" md="4">
							<v-row dense>
								<!-- Campo 1: owner (razón social / RUC) -->
								<v-col cols="12">
									<div class="caption mb-1">
										Razón social o RUC del proveedor
									</div>
									<search-document
										v-model="filters.document"
										entry="name"
										owner-type="PROVIDER"
										@input="listenOwner"
									/>
								</v-col>

								<!-- Campo 2: palabras clave en documentos -->
								<v-col cols="12" class="mt-2">
									<v-text-field
										v-model="inputSearch"
										label="Ingrese palabras clave relacionadas al contrato o adenda"
										persistent-placeholder
										hide-details
										outlined
										dense
										clearable
										:loading="loadingSearch"
										prepend-inner-icon="mdi-magnify"
										@input="listenSearch"
									/>
								</v-col>

								<v-col cols="12" class="d-flex justify-end">
									<v-checkbox
										v-model="moreFilters"
										label="Filtro avanzado"
										dense
										hide-details
										class="mt-1"
										@change="onToggleAdvanced"
									/>
								</v-col>

								<template v-if="moreFilters">
									<v-col cols="12">
										<div class="caption mb-1 text--secondary">Fecha de registro:</div>
										<v-row dense>
											<v-col>
												<v-text-field
													v-model="filters.date_from"
													type="date"
													label="Desde"
													outlined
													dense
													hide-details
													clearable
												/>
											</v-col>
											<v-col>
												<v-text-field
													v-model="filters.date_to"
													type="date"
													label="Hasta"
													outlined
													dense
													hide-details
													clearable
													:min="filters.date_from"
												/>
											</v-col>
										</v-row>
									</v-col>
								</template>
							</v-row>

							<!-- Resultados -->
							<v-sheet outlined rounded min-height="400px" class="mt-4">
								<div class="pa-4 text--secondary caption">
									Resultados de búsqueda:
								</div>

								<div v-if="loadingSearch" class="text-center pa-8">
									<v-progress-circular indeterminate color="primary" size="32" />
								</div>

								<template v-else>
									<div
										v-for="item in supplies"
										:key="item.id"
										:class="['result-item', selectedId === item.id ? 'selected' : '']"
										@click="selectItem(item)"
									>
										<div class="pa-4">
											<v-row justify="space-between" align="center" dense>
												<v-col>
													<div class="primary--text text-subtitle-2 font-weight-bold">
														{{ item.name }}
													</div>
													<div class="text-body-2 text--secondary">
														{{ item.razon_social }}
													</div>
													<div class="caption text--disabled">
														{{ item.owner.name }}
													</div>
													<div class="mt-1">
														<v-chip
															v-if="hasKeyword(item)"
															x-small
															color="orange lighten-3"
															class="mr-1"
														>
															Keywords
														</v-chip>
													</div>
												</v-col>
												<v-col cols="auto">
													<span class="success--text caption font-weight-bold">
														{{ keywordCountLabel(item) }}
													</span>
												</v-col>
											</v-row>

											<!-- Sub-filas: documentos con matches -->
											<div
												v-for="doc in getMatchedDocs(item)"
												:key="doc.id"
												class="result-document mt-1"
												@click.stop="selectDocument(item, doc)"
											>
												<v-row align="center" dense>
													<v-col cols="auto">
														<v-icon small color="green darken-2" class="mr-1 mb-1 ml-2">
															mdi-arrow-right-bottom
														</v-icon>
														<span class="caption">{{ doc.name }}</span>
													</v-col>
													<v-col cols="auto">
														<v-chip
															x-small
															dark
															label
															:color="doc.type === 'CONTRATO' ? 'blue darken-1' : 'orange darken-1'"
														>
															{{ doc.type }}
														</v-chip>
													</v-col>
													<v-col cols="auto" class="success--text caption ml-auto mr-2">
														{{ docMatchLabel(doc) }}
													</v-col>
												</v-row>
											</div>
										</div>
										<v-divider />
									</div>

									<div
										v-if="supplies.length === 0"
										class="text-center pa-8 text--disabled caption"
									>
										{{ hasSearchTerm ? 'Sin resultados para la búsqueda.' : 'Ingrese un término para buscar.' }}
									</div>
								</template>

								<v-pagination
									v-if="suppliesPagination && suppliesPagination.total_pages > 1"
									v-model="filters.page"
									:length="suppliesPagination.total_pages"
									class="my-4"
									@input="search"
								/>
							</v-sheet>
						</v-col>

						<!-- ── Panel derecho ── -->
						<v-col cols="12" md="8">
							<div class="d-flex">
								<v-divider class="ml-2 mr-6" vertical />

								<v-sheet min-height="500px" width="100%" class="pa-2" rounded>
									<div class="d-flex align-center mb-4 text--secondary caption">
										<v-icon left small>mdi-loupe</v-icon>
										Información complementaria
									</div>

									<!-- Cargando detalle -->
									<div v-if="loadingDetail" class="text-center mt-16">
										<v-progress-circular indeterminate color="primary" size="36" />
									</div>

									<!-- Nada seleccionado -->
									<div v-else-if="!previewType" class="text-center text--disabled mt-16">
										<v-icon size="48" color="grey lighten-2">mdi-file-search-outline</v-icon>
										<div class="mt-2 caption">Selecciona un resultado para ver el detalle</div>
									</div>

									<!-- Keyword preview -->
									<supply-keyword-preview
										v-else-if="previewType === 'keyword'"
										:result="selected"
										:filters="filters"
										:doc-id="selectedDocId"
									/>

									<!-- Detalle normal -->
									<template v-else-if="previewType === 'detail'">
										<div class="text-h6 mb-1">{{ selected.name }}</div>
										<div class="primary--text mb-4">
											{{ selected.owner.name }}
											<v-chip x-small class="ml-2">{{ selected.owner.type }}</v-chip>
										</div>

										<div class="mb-4">
											<div class="font-weight-bold text--secondary caption text-uppercase">Detalles</div>
											<v-divider class="mb-2" />
											<v-row justify="space-between" class="my-1" dense>
												<v-col cols="auto" class="text--secondary">Razón social</v-col>
												<v-col cols="auto">{{ selected.razon_social || '—' }}</v-col>
											</v-row>
											<v-row justify="space-between" class="my-1" dense>
												<v-col cols="auto" class="text--secondary">Proveedor</v-col>
												<v-col cols="auto">{{ selected.owner.name }}</v-col>
											</v-row>
											<v-row justify="space-between" class="my-1" dense>
												<v-col cols="auto" class="text--secondary">Doc. identidad</v-col>
												<v-col cols="auto">{{ selected.owner.document || '—' }}</v-col>
											</v-row>
											<v-row justify="space-between" class="my-1" dense>
												<v-col cols="auto" class="text--secondary">Inicio de vigencia</v-col>
												<v-col cols="auto">{{ formatDateOnly(selected.start_date) || '—' }}</v-col>
											</v-row>
											<v-row justify="space-between" class="my-1" dense>
												<v-col cols="auto" class="text--secondary">Fin de vigencia</v-col>
												<v-col cols="auto">{{ formatDateOnly(selected.end_date) || '—' }}</v-col>
											</v-row>
										</div>

										<!-- Contratos -->
										<v-sheet outlined rounded class="mb-4">
											<div class="px-4 pt-3 pb-1 d-flex align-center">
												<v-icon small left color="blue darken-1">mdi-file-document-outline</v-icon>
												<span class="font-weight-bold text--secondary">Contratos</span>
												<v-chip x-small class="ml-2" color="blue darken-1" dark>
													{{ (selected.documents.contrato || []).length }}
												</v-chip>
											</div>
											<v-divider />
											<v-data-table
												v-if="selected.documents.contrato && selected.documents.contrato.length"
												:headers="docHeaders"
												:items="selected.documents.contrato"
												:items-per-page="-1"
												hide-default-footer
												dense
											>
												<template v-slot:[`item.actions`]="{ item }">
													<div class="d-flex align-center justify-end" style="white-space: nowrap">
														<v-btn color="primary" small icon :loading="readingFile === item.id" @click="openFile(item)" v-if="item.file_url" title="Vista previa">
															<v-icon small>mdi-eye-outline</v-icon>
														</v-btn>
														<v-btn color="primary" small icon :href="item.file_url" :download="item.name" target="_blank" rel="noopener noreferrer" v-if="item.file_url" title="Descargar">
															<v-icon small>mdi-download</v-icon>
														</v-btn>
													</div>
												</template>
											</v-data-table>
											<div v-if="!selected.documents.contrato || !selected.documents.contrato.length" class="text-center pa-4 text--disabled caption">
												Sin contratos registrados
											</div>
										</v-sheet>

										<!-- Adendas -->
										<v-sheet outlined rounded class="mb-4">
											<div class="px-4 pt-3 pb-1 d-flex align-center">
												<v-icon small left color="orange darken-1">mdi-file-plus-outline</v-icon>
												<span class="font-weight-bold text--secondary">Adendas</span>
												<v-chip x-small class="ml-2" color="orange darken-1" dark>
													{{ (selected.documents.adenda || []).length }}
												</v-chip>
											</div>
											<v-divider />
											<v-data-table
												v-if="selected.documents.adenda && selected.documents.adenda.length"
												:headers="docHeaders"
												:items="selected.documents.adenda"
												:items-per-page="-1"
												hide-default-footer
												dense
											>
												<template v-slot:[`item.actions`]="{ item }">
													<div class="d-flex align-center justify-end" style="white-space: nowrap">
														<v-btn color="primary" small icon :loading="readingFile === item.id" @click="openFile(item)" v-if="item.file_url" title="Vista previa">
															<v-icon small>mdi-eye-outline</v-icon>
														</v-btn>
														<v-btn color="primary" small icon :href="item.file_url" :download="item.name" target="_blank" rel="noopener noreferrer" v-if="item.file_url" title="Descargar">
															<v-icon small>mdi-download</v-icon>
														</v-btn>
													</div>
												</template>
											</v-data-table>
											<div v-if="!selected.documents.adenda || !selected.documents.adenda.length" class="text-center pa-4 text--disabled caption">
												Sin adendas registradas
											</div>
										</v-sheet>

										<div class="mt-2 d-flex justify-end">
											<v-btn color="primary" small outlined text class="text-none" :to="{ name: 'ReadAgreement', params: { agreementId: selected.id } }">
												<v-icon left small>mdi-open-in-new</v-icon>
												Ver detalle completo
											</v-btn>
										</div>
									</template>
								</v-sheet>
							</div>
						</v-col>
					</v-row>
						</v-card-text>
					</v-tab-item>

					<!-- ── Tab 1: Listado General ── -->
					<v-tab-item>
						<v-card-text class="pa-6">

							<!-- Filtros -->
							<v-row dense class="mb-4">
								<v-col cols="12" md="3">
									<v-text-field
										v-model="generalFilters.q"
										label="Buscar por nombre"
										outlined dense hide-details clearable
										prepend-inner-icon="mdi-magnify"
										@input="onGeneralSearchInput"
									/>
								</v-col>
								<v-col cols="12" md="4">
									<v-autocomplete
										v-model="generalFilters.owner_id"
										:items="generalOwners"
										item-value="id"
										:item-text="ownerText"
										label="Filtrar por proveedor"
										outlined dense hide-details clearable
										@change="onGeneralFilterChange"
									/>
								</v-col>
								<v-col cols="12" md="2">
									<v-text-field
										v-model="generalFilters.vigencia_from"
										type="date"
										label="Vigencia desde"
										outlined dense hide-details clearable
										@change="onGeneralFilterChange"
									/>
								</v-col>
								<v-col cols="12" md="2">
									<v-text-field
										v-model="generalFilters.vigencia_to"
										type="date"
										label="Vigencia hasta"
										outlined dense hide-details clearable
										:min="generalFilters.vigencia_from"
										@change="onGeneralFilterChange"
									/>
								</v-col>
								<v-col cols="12" md="1" class="d-flex align-center">
									<v-btn
										small text color="secondary" class="text-none"
										:disabled="!hasGeneralFilters"
										@click="clearGeneralFilters"
									>
										Limpiar
									</v-btn>
								</v-col>
							</v-row>

							<v-data-table
								:headers="generalHeaders"
								:items="filteredGeneralItems"
								:loading="generalLoading"
								:items-per-page="10"
								dense
							>
								<template v-slot:[`item.start_date`]="{ item }">
									{{ formatDateOnly(item.start_date) || '—' }}
								</template>
								<template v-slot:[`item.end_date`]="{ item }">
									{{ formatDateOnly(item.end_date) || '—' }}
								</template>
								<template v-slot:[`item.created_at`]="{ item }">
									{{ formatDate(item.created_at) || '—' }}
								</template>
								<template v-slot:[`item.owner`]="{ item }">
									<span>{{ item.owner.name }}</span>
									<v-chip x-small class="ml-1" outlined>
										{{ item.owner.type === 'PROVIDER' ? 'Proveedor' : 'Cliente' }}
									</v-chip>
								</template>
								<template v-slot:[`item.actions`]="{ item }">
									<div class="d-flex align-center justify-end" style="white-space: nowrap">
										<v-btn
											icon small color="primary"
											:to="{ name: 'ReadAgreement', params: { agreementId: item.id } }"
											title="Ver detalle"
										>
											<v-icon small>mdi-open-in-new</v-icon>
										</v-btn>
										<v-btn
											icon small color="error"
											title="Eliminar"
											@click="openDeleteDialog(item)"
										>
											<v-icon small>mdi-delete-outline</v-icon>
										</v-btn>
									</div>
								</template>
							</v-data-table>

						</v-card-text>

						<!-- Dialog de confirmación de eliminación -->
						<v-dialog v-model="deleteDialog" max-width="420" persistent>
							<v-card>
								<v-card-title class="text-subtitle-1 font-weight-bold">
									Confirmar eliminación
								</v-card-title>
								<v-card-text>
									¿Está seguro de eliminar
									<strong>{{ deleteTarget && deleteTarget.name }}</strong>?
									Esta acción no se puede deshacer.
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn text class="text-none" :disabled="deleteLoading" @click="deleteDialog = false">
										Cancelar
									</v-btn>
									<v-btn color="error" class="text-none" :loading="deleteLoading" @click="confirmDelete">
										Eliminar
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</v-tab-item>

				</v-tabs-items>
			</v-card>
		</div>
	</v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { formatDate, formatDateOnly, showSnack } from '@/helpers/globalHelpers';
import SearchDocument from '@/components/contract/search/elements/SearchDocument/SearchDocument.vue';
import SupplyKeywordPreview from './SupplyKeywordPreview.vue';
import { listSupply, deleteSupply } from '@/store/modules/supply/service/supply.service';
import { listOwners } from '@/store/modules/owner/service/owner.service';

export default {
	name: 'SearchSupplyView',

	components: { SearchDocument, SupplyKeywordPreview },

	data() {
		return {
			activeTab: parseInt(localStorage.getItem('supply_search_tab') || '0'),
			allGeneralItems: [],
			generalOwners: [],
			generalLoading: false,
			generalFilters: {
				q: null,
				owner_id: null,
				vigencia_from: null,
				vigencia_to: null,
			},
			deleteDialog: false,
			deleteTarget: null,
			deleteLoading: false,
			generalHeaders: [
				{ text: 'Nombre', value: 'name', sortable: false },
				{ text: 'Proveedor / Cliente', value: 'owner', sortable: false },
				{ text: 'Inicio de vigencia', value: 'start_date', sortable: false },
				{ text: 'Fin de vigencia', value: 'end_date', sortable: false },
				{ text: 'Fecha de registro', value: 'created_at', sortable: false },
				{ text: '', value: 'actions', sortable: false, align: 'end', width: '100px' },
			],
			inputSearch: null,
			moreFilters: false,
			searchTimeout: null,
			selectedId: null,
			selectedDocId: null,
			selected: null,
			previewType: null,
			readingFile: null,
			loadingDetail: false,
			filters: {
				page: 1,
				pagination: true,
				per_page: process.env.VUE_APP_PAGINATION_PER_PAGE || 10,
				q: null,
				document: null,
				date_from: null,
				date_to: null,
			},
			docHeaders: [
				{ text: 'Nombre', value: 'name', sortable: false },
				{ text: '', value: 'actions', sortable: false, align: 'end', width: '90px' },
			],
			breadcrumbs: [
				{ text: 'Inicio', link: true, exact: true, disabled: false, to: { name: 'Dashboard' } },
				{ text: 'Abastecimiento', link: true, exact: true, disabled: false, to: { name: 'AgreementHome' } },
				{ text: 'Búsqueda', disabled: true, href: '/' },
			],
		};
	},

	computed: {
		...mapState('supply', ['supplies', 'suppliesPagination', 'loadingSearch']),
		...mapState('owner', ['owners']),

		hasSearchTerm() {
			return !!(this.filters.q || this.filters.document);
		},

		filteredGeneralItems() {
			let items = this.allGeneralItems;
			const q = (this.generalFilters.q || '').trim().toLowerCase();
			if (q) {
				items = items.filter(item =>
					(item.name || '').toLowerCase().includes(q) ||
					(item.razon_social || '').toLowerCase().includes(q)
				);
			}
			if (this.generalFilters.owner_id) {
				items = items.filter(item => item.owner?.id === this.generalFilters.owner_id);
			}
			if (this.generalFilters.vigencia_from) {
				items = items.filter(item => item.start_date >= this.generalFilters.vigencia_from);
			}
			if (this.generalFilters.vigencia_to) {
				items = items.filter(item => item.end_date <= this.generalFilters.vigencia_to);
			}
			return items;
		},

		hasGeneralFilters() {
			return !!(this.generalFilters.q || this.generalFilters.owner_id ||
				this.generalFilters.vigencia_from || this.generalFilters.vigencia_to);
		},
	},

	watch: {
		'filters.date_from'() { this.listenFilters(); },
		'filters.date_to'() { this.listenFilters(); },
		activeTab(val) {
			localStorage.setItem('supply_search_tab', val);
			if (val === 1 && this.allGeneralItems.length === 0) {
				this.loadAllGeneralItems();
			}
		},
	},

	created() {
		if (this.activeTab === 1) {
			this.loadAllGeneralItems();
		}
	},

	beforeDestroy() {
		clearTimeout(this.searchTimeout);
		this.$store.commit('supply/SET_SUPPLIES', []);
		this.$store.commit('supply/SET_SUPPLIES_PAGINATION', null);
	},

	methods: {
		...mapActions('supply', ['searchSupply', 'getSupplyDetail']),
		...mapActions('contract', ['signedFileUrl']),
		formatDate,
		formatDateOnly,

		hasKeyword(item) {
			const docs = [
				...(item.documents?.contrato || []),
				...(item.documents?.adenda || []),
			];
			return docs.some(d => Array.isArray(d.supplyDocumentPages) && d.supplyDocumentPages.length > 0);
		},

		keywordCountLabel(item) {
			const docs = [
				...(item.documents?.contrato || []),
				...(item.documents?.adenda || []),
			];
			const count = docs.reduce((n, d) => n + (d.supplyDocumentPages?.length || 0), 0);
			if (count === 1) return '1 resultado';
			if (count > 1) return `${count} resultados`;
			return null;
		},

		getMatchedDocs(item) {
			const docs = [
				...(item.documents?.contrato || []),
				...(item.documents?.adenda || []),
			];
			return docs.filter(d => Array.isArray(d.supplyDocumentPages) && d.supplyDocumentPages.length > 0);
		},

		docMatchLabel(doc) {
			const n = doc.supplyDocumentPages?.length || 0;
			if (n === 1) return '1 resultado';
			if (n > 1) return `${n} resultados`;
			return null;
		},

		async search() {
			if (!this.filters.q && !this.filters.document) {
				this.$store.commit('supply/SET_SUPPLIES', []);
				this.$store.commit('supply/SET_SUPPLIES_PAGINATION', null);
				return;
			}

			const params = { ...this.filters };
			if (!params.q) delete params.q;
			if (!params.document) delete params.document;
			if (!params.date_from) delete params.date_from;
			if (!params.date_to) delete params.date_to;

			const { ok, error } = await this.searchSupply(params);
			if (!ok) {
				const msg = error?.data?.message;
				showSnack(Array.isArray(msg) ? msg.join(' ') : msg || 'Error al buscar', 'error');
			}
		},

		listenSearch(value) {
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
				this.filters.q = value || null;
				this.filters.page = 1;
				this.resetSelection();
				this.search();
			}, 800);
		},

		listenOwner(value) {
			this.filters.document = value || null;
			this.filters.page = 1;
			this.resetSelection();
			this.search();
		},

		listenFilters() {
			this.filters.page = 1;
			this.search();
		},

		onToggleAdvanced(val) {
			if (!val) {
				this.filters.date_from = null;
				this.filters.date_to = null;
			}
		},

		resetSelection() {
			this.selectedId = null;
			this.selectedDocId = null;
			this.selected = null;
			this.previewType = null;
		},

		async selectItem(item) {
			this.selectedId = item.id;
			this.selectedDocId = null;

			if (this.hasKeyword(item)) {
				this.selected = item;
				this.previewType = 'keyword';
				return;
			}

			this.selected = null;
			this.previewType = null;
			this.loadingDetail = true;
			const { ok, response, error } = await this.getSupplyDetail(item.id);
			this.loadingDetail = false;

			if (!ok) {
				const status = error?.status;
				const msg = status === 403
					? 'No tienes permiso para ver este registro.'
					: status === 404
						? 'El registro no fue encontrado.'
						: error?.data?.message || 'Error al cargar el detalle.';
				showSnack(Array.isArray(msg) ? msg.join(' ') : msg, 'error');
				this.selectedId = null;
				return;
			}

			this.selected = response?.data || null;
			this.previewType = 'detail';
		},

		selectDocument(item, doc) {
			this.selectedId = item.id;
			this.selectedDocId = doc.id;
			this.selected = item;
			this.previewType = 'keyword';
		},

		ownerText(item) {
			return item.document ? item.name + ' - ' + item.document : item.name;
		},

		onGeneralSearchInput(value) {
			this.generalFilters.q = value || null;
		},

		onGeneralFilterChange() {
			// filteredGeneralItems computed reacts automatically
		},

		clearGeneralFilters() {
			this.generalFilters.q = null;
			this.generalFilters.owner_id = null;
			this.generalFilters.vigencia_from = null;
			this.generalFilters.vigencia_to = null;
		},

		openDeleteDialog(item) {
			this.deleteTarget = item;
			this.deleteDialog = true;
		},

		async confirmDelete() {
			if (!this.deleteTarget) return;
			this.deleteLoading = true;
			try {
				await deleteSupply(this.deleteTarget.id);
				showSnack('Abastecimiento eliminado exitosamente.', 'success');
				this.deleteDialog = false;
				this.deleteTarget = null;
				this.loadAllGeneralItems();
			} catch {
				showSnack('Error al eliminar el abastecimiento.', 'error');
			} finally {
				this.deleteLoading = false;
			}
		},

		async loadAllGeneralItems() {
			this.generalLoading = true;
			try {
				const companyId = localStorage.getItem('company_id');
				const [supplyRes, ownersRes] = await Promise.all([
					listSupply({ company_id: companyId, pagination: false }),
					listOwners({ type: 'PROVIDER' }),
				]);
				this.allGeneralItems = supplyRes?.data || [];
				this.generalOwners = ownersRes?.owners || [];
			} catch {
				showSnack('Error al cargar el listado', 'error');
			} finally {
				this.generalLoading = false;
			}
		},

		async openFile(item) {
			this.readingFile = item.id;
			try {
				const { error, response } = await this.signedFileUrl({ fileUrl: item.file_url });
				if (error) {
					showSnack('No se pudo abrir el archivo', 'error');
					return;
				}
				const url = this.$router.resolve({
					name: 'ReadFile',
					query: { url: response.signedUrl },
				}).href;
				window.open(url, '_blank');
			} finally {
				this.readingFile = null;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.result-item {
	cursor: pointer;
	transition: background-color 0.2s;
	&:hover,
	&.selected {
		background-color: #ecf1f5;
	}
}
.result-document {
	border-radius: 4px;
	cursor: pointer;
	transition: background-color 0.2s;
	&:hover {
		background-color: #d7e3ed;
	}
}
</style>
